import React, { useContext } from 'react'
import Button from '../../../atoms/button/button'
import { StaticImage } from 'gatsby-plugin-image'
import { siteUrl } from '../../../../shared/utils/siteUrl'
import { pushEventData } from '../../../../utils/pushEventDataLayer'
import { Context } from '../../../../context/app-context'
import userSessionStorage from '../../../../utils/userSessionStorage'
import { jsonToHash } from '../../../../utils/crypto'
import {
  getButtonText,
  getContentText2,
  getTitleInfo,
} from './tab1.textbylocale'

const Tab1 = ({ isMobile }) => {
  const handlerGoToRegister = () => {
    window.open(siteUrl + '/registro', '_BLANK')
  }

  const { dispatch } = useContext(Context)
  const session = new userSessionStorage()
  const userInfo = session.getUserInfo()

  const toggleButton = async evt => {
    if (evt) {
      let text = evt.target?.innerText

      if (text) {
        pushEventData({
          event: 'Interacciones_Home_RompeTabus',
          category: 'Inicio Sesion',
          label: text,
          user_data: userInfo && [
            await jsonToHash({
              nombre: userInfo.name,
              apellido: userInfo.lastName,
              celular: userInfo.cellPhone,
              correo: userInfo.email,
              ciudad: userInfo.location.cityName,
              departamento: userInfo.location.countryStateName,
              pais: userInfo.countryName,
            }),
          ],
          log_status: userInfo ? 'Yes' : 'Not',
        })
      }
    }
    handlerGoToRegister()
  }

  const handleDataLayer = async label => {
    pushEventData({
      event: 'Interacciones_Enlaces',
      action: 'link',
      label: label,
      user_data: userInfo && [
        await jsonToHash({
          nombre: userInfo.name,
          apellido: userInfo.lastName,
          celular: userInfo.cellPhone,
          correo: userInfo.email,
          ciudad: userInfo.location.cityName,
          departamento: userInfo.location.countryStateName,
          pais: userInfo.countryName,
        }),
      ],
      log_status: userInfo ? 'Yes' : 'Not',
    })
  }

  const handleLogin = () => {
    handleDataLayer('Inicia sesión')
    dispatch({
      type: 'set-modal',

      modalActive: {
        type: 'login',
        wrapperProps: { blur: true },
        props: {
          close: () => {
            dispatch({ type: 'clear-modal' })
            // navigate('/')
          },
          onEnd: () => {
            // window.location.reload()
            dispatch({ type: 'clear-modal' })
            dispatch({
              type: 'set-modal',

              modalActive: {
                type: 'updateData',
                wrapperProps: { blur: true },
                props: {
                  forceUpdate: true,
                  close: () => {
                    dispatch({ type: 'clear-modal' })
                  },
                  success: () => {
                    dispatch({ type: 'clear-modal' })
                    window.location.reload()
                  },
                },
              },
            })
            //navigate('/')
          },
          // mobile: isMobile,
        },
      },
    })
  }

  return (
    <>
      {isMobile && <h3>Inicio Sesión</h3>}
      <StaticImage
        src="../../../../assets/images/tabs-section/logoMbTab1.webp"
        alt="Logo inicio sesion"
        className="tab-content__imgTab1"
        placeholder="blurred"
      />
      <div className="tab-content__info">
        <h3>{getTitleInfo(isMobile)}</h3>
        <br />
        <p className="tab-content__text">
          {getContentText2()}
          <span className="--pink">
            {' '}
            <a onClick={() => handleLogin()}>Iniciar sesión.</a>
          </span>
          <br />
          <br />
          Si aún no estás registrada, ¡tranquila!
        </p>
        <Button className="--btnTabs" onClick={toggleButton}>
          {getButtonText()}
        </Button>
      </div>
    </>
  )
}

export default Tab1
